import { TFunction } from 'i18next'

import { EInvoiceAddressSchemeType } from '../../../../../enums/eInvoiceAddressSchemeType'
import { EInvoiceScheme } from '../../../../../types/eInvoiceScheme'

export const getPublicTypeEInvoiceAddressTooltipMap = (
  t: TFunction,
): Partial<Record<EInvoiceAddressSchemeType, string>> => ({
  [EInvoiceAddressSchemeType.LWID]: t('customer_modal.form.e_invoice_address.LWID.tooltip.label'),
})

export const getPublicTypeEInvoiceAddressTooltip = (t: TFunction, scheme: EInvoiceScheme) => {
  const tooltipMap = getPublicTypeEInvoiceAddressTooltipMap(t)
  return scheme ? tooltipMap[scheme] || '' : ''
}
